
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getLanguagesHelper } from '@/heplers';
import BlogLink from '@/components/docs-main/blog-pages/BlogLink.vue';
import { parseHrefHelper } from '@/heplers/stringHelpers';

@Component({
  components: { BlogLink },
  filters: {
    parseHref: (url: string) => {
      return parseHrefHelper(url, '/docs/');
    },
    getLanguages: getLanguagesHelper,
  },
  metaInfo() {
    return {
      title: "HowTo's",
    };
  },
})
export default class HowTo extends Vue {
  @Getter('getContent') data: any;
}
